var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-warning mr-3 btn-tab"},[_vm._v("test tag")])}
var staticRenderFns = []

export { render, staticRenderFns }